export const EDIT_PROFILE = {
  EDIT_PROFILE: 'PROFILE_EDIT_PROFILE',
  EDIT_PROFILE_SUCCESS: 'PROFILE_EDIT_PROFILE_SUCCESS',
  EDIT_PROFILE_FAILED: 'PROFILE_EDIT_PROFILE_FAILED',
  EDIT_PHOTO: 'PROFILE_EDIT_PHOTO',
  EDIT_PHOTO_SUCCESS: 'PROFILE_EDIT_PHOTO_SUCCESS',
  EDIT_PHOTO_FAILED: 'PROFILE_EDIT_PHOTO_FAILED',
};
